
import External from './components/External';

export default {
  i18nComponentKey: 'WidgetProductReviewsExternal.WidgetProductReviewsExternalPc',
  name: 'WidgetProductReviewsExternalPc',
  components: { External }
};
